<script>
import { debounce, trim } from 'lodash'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import Reason from './components-v2/reason_delete'
import EditCustomerSale from './components-v2/edit-customer-sale.vue'
import CustomerLoanRequest from './components-v2/customer-loan-request.vue'
import * as FileDownload from 'downloadjs'

export default {
  name: 'saleInvoice',
  components: {
    EditCustomerSale,
    CustomerLoanRequest,
  },
  data() {
    return {
      exporting: false,
      loading: false,
      isEditCustomer: false,
      showLoanRequest: false,
      branchs: [],
      locations: [],
      model: {
        deleted_reason: null
      },
      errors: new Errors(),
      stockOutId: undefined,
      show_pdf: false,
      waiting: false,
      src: undefined,
      stockOutRow: {}
    }
  },
  mounted() {
    this.getBranch()
    this.branch_id = [this.$store.state.authUser.user.default_branch.branch_id]
    this.changeBranch()
    this.location_id = [
      this.$store.state.authUser.user.default_location.location_id
    ]
    this.fetchData()
  },
  computed: {
    ...mapState('saleInvoiceStore', ['resources', 'pagination']),
    branch_id: {
      get() {
        return this.$store.state.saleInvoiceStore.branch_id
      },
      set(newValue) {
        this.$store.commit('saleInvoiceStore/SET_BRANCH_ID', newValue)
      }
    },
    location_id: {
      get() {
        return this.$store.state.saleInvoiceStore.location_id
      },
      set(newValue) {
        this.$store.commit('saleInvoiceStore/SET_LOCATION_ID', newValue)
      }
    },
    isPaid: {
      get() {
        return this.$store.state.saleInvoiceStore.is_paid
      },
      set(newValue) {
        this.$store.commit('saleInvoiceStore/SET_IS_PAID', newValue)
      }
    },
    search: {
      get() {
        return this.$store.state.saleInvoiceStore.search
      },
      set(newValue) {
        this.$store.commit('saleInvoiceStore/SET_SEARCH', newValue)
        this.$store.commit('saleInvoiceStore/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.saleInvoiceStore.dateRange
      },
      set(newValue) {
        this.$store.commit('saleInvoiceStore/SET_DATE_RANGE', newValue)
      }
    },
    columns() {
      return [
        {
          title: this.$t('saleInvoice.branchName'),
          slot: 'branchName',
          width: 175
        },
        {
          title: this.$t('saleInvoice.invoiceDate'),
          key: 'stock_out_date',
          width: 120
        },
        {
          title: this.$t('saleInvoice.invoiceNumber'),
          key: 'invoice_no',
          width: 180
        },
        {
          title: this.$t('saleInvoice.refInvoice'),
          key: 'reference_no',
          width: 140
        },
        {
          title: this.$t('saleInvoice.customerName'),
          key: 'customer_name',
          width: 175
        },
        {
          title: this.$t('saleInvoice.subTotal'),
          slot: 'subTotal',
          width: 100
        },
        {
          title: this.$t('saleInvoice.discountAmount'),
          slot: 'discountAmount',
          width: 120
        },
        {
          title: this.$t('saleInvoice.vatAmount'),
          slot: 'vatAmount',
          width: 120
        },
        {
          title: this.$t('saleInvoice.amountPaid'),
          slot: 'amountPaid',
          width: 120
        },
        {
          title: this.$t('saleInvoice.amountDue'),
          slot: 'amountDue',
          width: 120
        },
        {
          title: this.$t('saleInvoice.receiptAmountPaid'),
          slot: 'receiptAmountPaid',
          width: 120
        },
        {
          title: this.$t('saleInvoice.nextPaymentDate'),
          key: 'next_payment_date',
          width: 155
        },
        {
          title: this.$t('saleInvoice.isPaid'),
          slot: 'isPaid',
          width: 100,
          align: 'center',
          fixed: 'right'
        },
        {
          title: this.$t('saleInvoice.saleName'),
          key: 'sale_name',
          width: 150,
          className: 'ts-whitespace-no-wrap'
        },
        {
          title: this.$t('saleInvoice.createdBy'),
          slot: 'createdBy',
          width: 120
        },
        {
          title: this.$t('saleInvoice.remark'),
          key: 'remarks',
          width: 120
        },
        {
          title: this.$t('saleInvoice.refLoanNumber'),
          key: 'ref_loan_number',
          width: 150,
          className: 'ts-whitespace-no-wrap'
        },
        {
          title: this.$t('actions'),
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 150
        }
      ]
    }
  },
  methods: {
    ...mapActions('saleInvoiceStore', ['fetch']),
    addNew() {
      this.$router.push({ name: 'wholesale-create' })
    },
    fetchData(attrubutes = {}) {
      this.loading = true
      this.fetch(attrubutes).finally(() => (this.loading = false))
    },
    displayAmount(row, field) {
      let amount = row[field]
      if (
        row.input_currency_id !== row.currency_id &&
        row.input_currency_id !== null
      ) {
        amount = amount / parseFloat(row.fx_rate_ratio || 1)
      }

      if (row.currency_symbol) {
        return (
          row.currency_symbol +
          ' ' +
          this.$formatNumber(amount, row.currency_rounding || 2)
        )
      }
      const defaultCurrencySign = this.$store.state.authUser.sys_setting
        .default_currency_sign
      return (
        defaultCurrencySign +
        ' ' +
        this.$formatNumber(amount, row.currency_rounding || 2)
      )
    },
    getBranch() {
      this.$store
        .dispatch('security/user/getBranchAssignedForFilter')
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async changeBranch() {
      this.loading = true
      this.location_id = []
      await this.$store
        .dispatch('security/user/getWarehouseAssignedForFilter', {
          branch_id: this.branch_id
        })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteRecord(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('wholesale.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
            .dispatch('saleInvoiceStore/onDestroy', {
              id: record.stock_out_id,
              data: this.model
            })
            .then(response => {
              this.$toasted.success(response.data.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(({ response }) => {
              this.$toasted.error(response.data.message)
              this.errors = new Errors(response.data.errors)
              return Promise.reject(response)
            })
        },
        onCancel() {}
      })
    },
    reprintReport(record) {
      this.show_pdf = true
      this.waiting = true
      this.$store
        .dispatch('wholesale/operation/reprint', record.stock_out_id)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    // reprintReport(record) {
    //   this.show_pdf = true
    //   this.waiting = true
    //   this.$store
    //     .dispatch('saleInvoiceStore/onPreviewPdf', record.stock_out_id)
    //     .then(response => {
    //       this.src = response.data.url
    //     })
    //     .catch(response => {
    //       this.errors = new Errors(response.data.errors)
    //     })
    //     .finally(() => {
    //       this.waiting = false
    //     })
    // },
    editSaleCustomer(record) {
      this.isEditCustomer = true
      this.stockOutRow = record
    },
    onExport(attributes) {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('saleInvoiceStore/exportExcel', { ...attributes })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.exporting = false
        })
    },
    requestLoan(record) {
      this.showLoanRequest = true
      this.stockOutRow = record
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/operation/RESET_STATE')
    next()
  }
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('saleInvoice.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('saleInvoice.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-between">
          <div class="ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="true"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
            <ts-button
              color="success"
              @click.prevent="onExport"
              :waiting="exporting"
              class="ml-2"
            >
              <i class="fas fa-file-excel"></i> {{ $t('export') }}
            </ts-button>
          </div>
          <div class="ts-flex ts-space-x-3">
            <a-radio-group
              v-model="isPaid"
              :default-value="undefined"
              button-style="solid"
              @change="fetchData()"
            >
              <a-radio-button :value="undefined">
                All
              </a-radio-button>
              <a-radio-button :value="true">
                Paid
              </a-radio-button>
              <a-radio-button :value="false">
                Unpaid
              </a-radio-button>
            </a-radio-group>
            <a-input
              v-tooltip="$t('wholesale.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="ts-grid ts-grid-cols-1 ts-gap-3">
                <div>
                  <label class="">{{ $t('saleInvoice.branchName') }}</label>
                  <a-select
                    class="ts-w-full"
                    v-model="branch_id"
                    :options="branchs"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                    @change="changeBranch"
                  >
                  </a-select>
                </div>
                <div>
                  <label class="">{{ $t('saleInvoice.warehourse') }}</label>
                  <a-select
                    class="ts-w-full"
                    v-model="location_id"
                    :options="locations"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                    @change="fetchData()"
                  >
                  </a-select>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        :loading="loading"
        highlight-row
        stripe
        ref="tableSaleInvoice"
        size="small"
      >
        <template slot-scope="{ row }" slot="branchName">
          {{ row.branch.branch_name_en }}
        </template>
        <template slot-scope="{ row }" slot="subTotal">
          <p class="ts-mb-0">{{ displayAmount(row, 'sub_total') }}</p>
        </template>
        <template slot-scope="{ row }" slot="discountAmount">
          <p class="ts-mb-0">{{ displayAmount(row, 'discount') }}</p>
        </template>
        <template slot-scope="{ row }" slot="vatAmount">
          <p class="ts-mb-0">{{ displayAmount(row, 'vat_amount') }}</p>
        </template>
        <template slot-scope="{ row }" slot="amountPaid">
          <p class="ts-mb-0">{{ displayAmount(row, 'amount_paid') }}</p>
        </template>
        <template slot-scope="{ row }" slot="amountDue">
          <p class="ts-mb-0">{{ displayAmount(row, 'amount_due') }}</p>
        </template>
        <template slot-scope="{ row }" slot="receiptAmountPaid">
          <p class="ts-mb-0">
            {{ displayAmount(row, 'receipt_amount_paid') }}
          </p>
        </template>
        <template slot-scope="{ row }" slot="isPaid">
          <i
            class="far fa-check-square ts-text-green-500"
            v-if="row.is_paid"
          ></i>
          <i class="far fa-window-close ts-text-red-500" v-else></i>
        </template>
        <template slot-scope="{ row }" slot="createdBy">
          <p class="ts-mb-0 ts-whitespace-no-wrap">
            {{ row.user.name }}
          </p>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div class="ts-space-x-3">
            <a
              href="#"
              v-tooltip="$t('wholesale.reprint')"
              class="text-primary"
              @click.prevent="reprintReport(row)"
            >
              <i class="fas fa-file-pdf ts-text-red-500"></i>
            </a>
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="editSaleCustomer(row)"
            >
              <i class="fas fa-user-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="$t('saleInvoice.requestLoan')"
              class="text-warning"
              @click.prevent="requestLoan(row)"
              v-if="row.is_paid === false && row.is_loan_request === false && row.receipts_count == 0"
              >
              <i class="fas fa-money-check-alt"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(row)"
            >
              <a href="#" :disabled="row._deleting">
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </div>
        </template>
      </Table>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>

    <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>

    <a-modal
      v-if="isEditCustomer"
      :visible="isEditCustomer"
      :title="$t('saleInvoice.editCustomer')"
      :footer="null"
      width="1000px"
      @cancel="() => (isEditCustomer = false)"
    >
      <EditCustomerSale @cancel="() => (isEditCustomer = false)" :stockOutRow="stockOutRow" />
    </a-modal>
    <a-modal
      v-if="showLoanRequest"
      :visible="showLoanRequest"
      :title="$t('saleInvoice.customerLoanRequest')"
      :footer="null"
      width="600px"
      @cancel="() => (showLoanRequest = false)"
    >
      <CustomerLoanRequest @cancel="() => (showLoanRequest = false)" @fetchData="fetchData" :stockOutRow="stockOutRow" />
    </a-modal>
  </div>
</template>
